import TitleV2 from './TitleV2'
export default TitleV2
